"use client";

import type * as React from "react";
import { useRouter } from "next/navigation";
import { BookingSearchForm } from "@/components/booking/BookingSearchForm";
import {
  buildBookingUrl,
  formValuesToSearchParams,
  type BookingSearchFormValues,
} from "@/lib/booking/search-params";

export const HomeBookingSection: React.FC = () => {
  const router = useRouter();

  const handleSearch = (values: BookingSearchFormValues) => {
    const params = formValuesToSearchParams(values);
    if (!params) {
      return;
    }
    router.push(buildBookingUrl(params));
  };

  return (
    <div className="mx-12 mt-8 sticky top-4">
      <BookingSearchForm variant="home" onSubmit={handleSearch} />
    </div>
  );
};
